import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorAlertService {
  private showCustomAlertSource = new Subject<boolean>();
  private errorMessagesSource = new Subject<string[]>();

  showCustomAlert$ = this.showCustomAlertSource.asObservable();
  errorMessages$ = this.errorMessagesSource.asObservable();

  showCustomAlert(show: boolean, errorMessages: string[] = []) {
    this.showCustomAlertSource.next(show);
    this.errorMessagesSource.next(errorMessages);
  }
}
